const AUTH_ERROR_MESSAGES = ['유효하지 않은 토큰', '토큰 검증 중 오류']

export const isAuthExpiredError = (error) =>
  AUTH_ERROR_MESSAGES.some((message) => error?.message?.includes(message))
